export default __webpack_public_path__ + "static/media/promotion-fill.23c6a6c0.svg";